export const SET_MODAL_V2_VISIBLE = (el, payload) => {
  el.modalId = payload;
}
